'use strict';

declare var pdfMake: any;

module Patersons {

    export class ReportDownloadService {
        pdfBuilder: PdfBuilder;
        report: AbstractReport;
        account: Account;
        q: ng.IQService;
        filter: ng.IFilterService;
        pdfBuilderService: PDFBuilderService;
        base64logo: string;
        userCompanyService: Patersons.UserCompanyService;
        userCompany: UserCompany;
        static $inject = ['$q', '$filter', 'pdfBuilderService','userCompanyService'];

        constructor($q, $filter, pdfBuilderService,userCompanyService) {
            this.q = $q;
            this.filter = $filter;
            this.pdfBuilderService = pdfBuilderService;
            this.userCompanyService = userCompanyService;
            this.userCompanyService.getUserCompany().then((company) => {
                this.userCompany = company;
            })
            this.pdfBuilderService.newPdfBuilderInstance().then((pdfBuilder) => {
                this.pdfBuilder = pdfBuilder
            })
        }
        downloadPdfFile(report: AbstractReport, account: Account) {
            this.report = report;
            this.account = account;

            var fileName = this.getFileName();
            this.getPdfTemplateDefinition().then((def)=> {
                var reportDefinition = this.getReportDefinition(def);
                //console.log(JSON.stringify(reportDefinition));
                pdfMake.createPdf(reportDefinition).download(fileName + '.pdf');
            })
        };
        downloadCsvFile(report: AbstractReport, account: Account) {
            this.report = report;
            this.account = account;

            var fileName = this.getFileName();

            this.makeCsv(fileName + '.csv');
        };

        makeCsv(filename) {
            var blob = this.createCsvFile();
            if (window.navigator.msSaveOrOpenBlob) {
                navigator.msSaveBlob(blob, filename);
            } else {
                var downloadLink = document.createElement('a');
                downloadLink.href = window.URL.createObjectURL(blob);
                downloadLink.target = '_blank';
                downloadLink.setAttribute('download', filename);

                document.body.appendChild(downloadLink);
                downloadLink.click();
                downloadLink.remove();
            }
        }

        //pdf and csv download
        getReportDefinition(doc) {
            switch (this.report.reportType) {
                case ReportType.CapitalTransactions:
                    return this.getCapitalTransactionStatement(doc);
                case ReportType.QuarterlyReports:
                    return this.getQuarterlyReportsReport(doc);
                case ReportType.Cash:
                    return this.getCashReport(doc);
                case ReportType.Income:
                    return this.getIncomeReport(doc);
                case ReportType.CapitalGains:
                    return this.getCapitalGainsReport(doc);
                case ReportType.UnrealisedCapitalGains:
                    return this.getUnrealisedCapitalGainsReport(doc);
                case ReportType.Performance:
                    return this.getPerformanceReport(doc);
                case ReportType.TaxReports:
                    return this.getTaxReportsReport(doc);
                case ReportType.Valuation:
                    return this.getValuationStatement(doc);
                case ReportType.StandardLedger:
                    return this.getStandardLedger(doc);
                default:
                    console.error('Unrecognised report type encountered: ' + this.report.reportType);
                    return null;
            }
        }
        getColumnDefinitions(reportType: ReportType) {
            switch (reportType) {
                case ReportType.CapitalTransactions:
                    return {
                        columnNames: ['tradeDate', 'settlementDate', 'quantity', 'code', 'description', 'unitPrice', 'grossAmount', 'brokerage', 'gst', 'netAmount'],
                        /*displayNames: [
                          { text: 'Trade Date', alignment: 'left'},
                          { text: 'Settlement Date',  alignment: 'left'},
                          { text: 'Quantity',  alignment: 'right'},
                          { text: 'Code',  alignment: 'left'},
                          { text: 'Description',  alignment: 'left'},
                          { text: 'Unit Price',  alignment: 'right'},
                          { text: 'Gross Amount',  alignment: 'right'},
                          { text: 'Brokerage',  alignment: 'right'},
                          { text: 'GST',  alignment: 'right'},
                          { text: 'Net Amount', alignment: 'right'},
                        ],*/
                        displayNames: [
                          'Trade Date',
                          'Settlement Date',
                          'Quantity',
                          'Code',
                          'Description',
                          'Unit Price',
                          'Gross Amount',
                          'Brokerage',
                          'GST',
                          'Net Amount'
                        ],
                        csvColumnNames: ['tradeDate', 'settlementDate', 'quantity', 'code', 'description', 'unitPrice', 'grossAmount', 'brokerage', 'gst', 'netAmount', 'tradeCategory'],
                        csvDisplayNames: ['Trade Date', 'Settlement Date', 'Quantity', 'Code', 'Description', 'Unit Price', 'Gross Amount', 'Brokerage', 'GST', 'Net Amount', 'Category'],
                        columnWidths: ['auto', 'auto', 'auto', 'auto', '*', 'auto', 'auto', 'auto', 'auto', 'auto']
                    };
                case ReportType.QuarterlyReports:
                    return {
                        columnNames: ["name"],
                        /*displayNames: [
                          {text: "Title", alignment: 'left'}
                        ],*/
                        displayNames: [
                           "Title"
                        ],
                        csvColumnNames: ["name"],
                        csvDisplayNames: ["Report Name"],
                        columnWidths: ['*']
                    };
                case ReportType.Cash:
                    return {
                        columnNames: ["date", "description", "debit", "credit", "balance"],
                        /*displayNames: [
                          { text: "Date", alignment: 'left'},
                          { text: "Description", alignment: 'left'},
                          { text: "Debit",  alignment: 'right'},
                          { text: "Credit",  alignment: 'right'},
                          { text: "Balance", alignment: 'right'}
                        ],*/
                        displayNames: [
                          "Date",
                          "Description",
                           "Debit",
                          "Credit",
                          "Balance"
                        ],
                        csvColumnNames: ["date", "description", "debit", "credit", "balance", "cashSecurityGroupName"],
                        csvDisplayNames: ["Date", "Description", "Debit", "Credit", "Balance", "Cash Security Group"],
                        columnWidths: ['auto', '*', 90, 90, 90]
                    };
                case ReportType.Income:
                    return {
                        columnNames: ['payDate', 'exDate', 'code', 'description', 'amount', 'frankingCredits', 'withholdingTax', 'gst'],

                        /*displayNames: [
                          { text:"Pay-Date", alignment: 'left'},
                          { text:"Ex-Date", alignment: 'left'},
                          { text:"Code", alignment: 'left'},
                          { text:"Description", alignment: 'left'},
                          { text:"Amount Received / Paid",alignment: 'right'},
                          { text:"Franking Credits", alignment: 'right'},
                          { text:"Withholding Tax", alignment: 'right'},
                          { text:"GST", alignment: 'right'}
                        ],*/
                        displayNames: [
                          "Pay-Date",
                          "Ex-Date",
                          "Code",
                          "Description",
                          "Amount Received / Paid",
                          "Franking Credits",
                          "Withholding Tax",
                          "GST"
                        ],
                        csvColumnNames: ['payDate', 'exDate', 'code', 'description', 'amount', 'frankingCredits', 'withholdingTax', 'gst', 'transType', 'subTransType'],
                        csvDisplayNames: ["Pay-Date", "Ex-Date", "Code", "Description", "Amount Received / Paid", "Franking Credits", "Withholding Tax", "GST", "Type", "SubType"],
                        //columnWidths: [50, 50, 40, "*", 90, 90, 90, 90]
                        columnWidths: [50, 50, '*', 200, 50, 50, 50, 50]
                    };
                case ReportType.CapitalGains:
                    return {
                        columnNames: ['purchaseDate', 'saleDate', 'quantity', 'costPrice', 'totalCost', 'reducedCostBase', 'indexedCostBase', 'discountedCostBase', 'capitalLoss', 'indexedGain', 'grossDiscountGain', 'otherGain', 'salePrice', 'capitalProceeds'],
                        /*displayNames: [
                          { text:'Purchase Date', alignment: 'left'},
                          { text:'Sale Date', alignment: 'left'},
                          { text:'Quantity', alignment: 'right'},
                          { text:'Capital Proceeds', alignment: 'right'},
                          { text:'Total Cost', alignment: 'right'},
                          { text:'Reduced Cost Base', alignment: 'right'},
                          { text:'Indexed Cost Base', alignment: 'right'},
                          { text:'Discount Cost Base', alignment: 'right'},
                          { text:'Capital Loss', alignment: 'right'},
                          { text:'Indexed Gain', alignment: 'right'},
                          { text:'Gross Discount Gain', alignment: 'right'},
                          { text:'Other Gain', alignment: 'right'},
                        ],*/
                        displayNames: [
                          'Purchase Date',
                          'Sale Date',
                          'Quantity',
                          'Cost Price',
                          'Total Cost',
                          'Reduced Cost Base',
                          'Indexed Cost Base',
                          'Discount Cost Base',
                          'Capital Loss',
                          'Indexed Gain',
                          'Gross Discount Gain',
                          'Other Gain',
                          'Sale Price',
                          'Capital Proceeds',
                        ],
                        csvColumnNames: ['purchaseDate', 'saleDate', 'quantity', 'costPrice', 'totalCost', 'reducedCostBase', 'indexedCostBase', 'discountedCostBase', 'capitalLoss', 'indexedGain', 'grossDiscountGain', 'otherGain', 'securityDescription', 'assetClass', 'salePrice', 'capitalProceeds'],
                        csvDisplayNames: ['Purchase Date', 'Sale Date', 'Quantity', 'Cost Price', 'Total Cost', 'Reduced Cost Base', 'Indexed Cost Base', 'Discount Cost Base', 'Capital Loss', 'Indexed Gain', 'Gross Discount Gain', 'Other Gain', 'Security Description', 'Asset Class', 'Sale Price', 'Capital Proceeds'],
                        columnWidths: ["*", "*", "*", "*", "*", "*", "*", "*", "*", "*", "*","*", "*", "*"]
                    }
                case ReportType.UnrealisedCapitalGains:
                    return {
                        columnNames: ['purchaseDate', 'quantity', 'costPrice', 'totalCost', 'reducedCostBase', 'indexedCostBase', 'discountedCostBase', 'capitalLoss', 'indexedGain', 'grossDiscountGain', 'otherGain', 'marketPrice', 'marketValue'],
                        /*displayNames: [
                          { text:'Purchase Date', alignment: 'left'},
                          { text:'Quantity', alignment: 'right'},
                          { text:'Market Value', alignment: 'right'},
                          { text:'Total Cost', alignment: 'right'},
                          { text:'Reduced Cost Base', alignment: 'right'},
                          { text:'Indexed Cost Base', alignment: 'right'},
                          { text:'Discounted Cost Base', alignment: 'right'},
                          { text:'Capital Loss', alignment: 'right'},
                          { text:'Indexed Gain', alignment: 'right'},
                          { text:'Gross Discount Gain', alignment: 'right'},
                          { text:'Other Gain', alignment: 'right'},
                        ],*/
                        displayNames: [
                          'Purchase Date',
                          'Quantity',
                          'Cost Price',
                          'Total Cost',
                          'Reduced Cost Base',
                          'Indexed Cost Base',
                          'Discounted Cost Base',
                          'Capital Loss',
                          'Indexed Gain',
                          'Gross Discount Gain',
                          'Other Gain',
                          'Market Price',
                          'Market Value',
                        ],
                        csvColumnNames: ['purchaseDate', 'quantity', 'costPrice', 'totalCost', 'reducedCostBase', 'indexedCostBase', 'discountedCostBase', 'capitalLoss', 'indexedGain', 'grossDiscountGain', 'otherGain', 'securityDescription', 'assetClass', 'marketPrice', 'marketValue'],
                        csvDisplayNames: ['Purchase Date', 'Quantity', 'Cost Price', 'Total Cost', 'Reduced Cost Base', 'Indexed Cost Base', 'Discounted Cost Base', 'Capital Loss', 'Indexed Gain', 'Gross Discount Gain', 'Other Gain', 'Security Description', 'Asset Class', 'Market Price', 'Market Value'],
                        columnWidths: ['*', '*', '*', '*', '*', '*', '*', '*', '*', '*', '*', '*', '*']
                    }
                case ReportType.Performance:
                    return {
                        columnNames: ['openMarketValue', 'netContributionsWithdrawals', 'netAssetMovement', 'income', 'expenses', 'managementFees', 'closedMarketValue', 'irr'],
                        /*displayNames: [
                          { text:'Open Market Value', alignment: 'right'},
                          { text:'Net Contributions / Withdrawals', alignment: 'right'},
                          { text:'Net Asset Movement', alignment: 'right'},
                          { text:'Income', alignment: 'right'},
                          { text:'Expenses', alignment: 'right'},
                          { text:'Management Fees', alignment: 'right'},
                          { text:'Closed Market Value', alignment: 'right'},
                          { text:'IRR', alignment: 'right'}
                        ],*/
                        displayNames: [
                          'Open Market Value',
                          'Net Contributions / Withdrawals',
                          'Net Asset Movement',
                          'Income',
                          'Expenses',
                          'Management Fees',
                          'Closed Market Value',
                          'IRR'
                        ],
                        csvColumnNames: ['openMarketValue', 'netContributionsWithdrawals', 'netAssetMovement', 'income', 'expenses', 'managementFees', 'closedMarketValue', 'irr'],
                        csvDisplayNames: ['Open Market Value', 'Net Contributions / Withdrawals', 'Net Asset Movement', 'Income', 'Expenses', 'Management Fees', 'Closed Market Value', 'IRR'],
                        columnWidths: ['*', 300]
                    }
                case ReportType.TaxReports:
                    return {
                        columnNames: ["name"],
                        /*displayNames: [
                          { text:"Title", alignment: 'left'}
                        ],*/
                        displayNames: [
                          "Title"
                        ],
                        csvColumnNames: ["name"],
                        csvDisplayNames: ["Report Name"],
                        columnWidths: ['*']
                    };
                case ReportType.Valuation:
                    
                    //remove Gross Yield, Estimated Income and Estimated Franking Credits for CG accounts
                    if(this.userCompany.enableFeature){
                        const result = {
                            columnNames: ["code", "securityName", "quantity", "costPrice", "totalCost", "price", "marketValue","profitOrLoss", "pctAssets", "estAnnualIncome", "estFrankingCredits", "estGrossYield"],
                            displayNames: [
                              "Code",
                              "Security Name",
                              "Quantity",
                              "Cost Price",
                              "Reduced Cost Base",
                              "Market Price",
                              "Market Value",
                              "Profit (Loss)",
                              "Pct. Assets",
                              "Historic Income",
                              "Historic Fr. Credits",
                              "Historic Gross Yield"
                            ],

                            columnNamesInternational: [
                                "code",
                                "currency",
                                "securityName",
                                "quantity",
                                "nativeCostPrice",
                                "nativeTotalCost",
                                "nativeMarketPrice",
                                "nativeMarketValue",
                                "nativeProfitLoss",
                                "totalCost",
                                "marketValue",
                                "profitOrLoss",
                                "pctAssets",
                                "estAnnualIncome"
                            ],

                            displayNamesInternational: [
                                "Code",
                                "Currency",
                                "Name",
                                "Quantity",
                                "Native Cost Price",
                                "Native Total Cost",
                                "Native Market Price",
                                "Native Market Value",
                                "Native Profit (Loss)",
                                "AUD Total Cost",
                                "AUD Market Value",
                                "AUD Profit (Loss)",
                                "Pct. Assets",
                                "Historic Income"
                            ],
                            csvColumnNames: ["code", "securityName", "quantity", "costPrice", "totalCost", "price", "marketValue", "profitOrLoss", "pctAssets", "estAnnualIncome", "estFrankingCredits", "estGrossYield"],
                            csvDisplayNames: ["Code", "Security Name", "Quantity", "Cost Price", "Reduced Cost Base", "Market Price", "Market Value","Profit (Loss)", "Pct. Assets", "Historic Income", "Historic Fr. Credits", "Historic Gross Yield"],
                            columnWidths: ["auto", "*", 50, 40, 60, 50, 60, 50, 40, 60, 50, 40],
                            columnWidthsInternational: ["auto", "auto", "*", 40, 40, 50, 50, 50, 40, 50, 50, 40, 40, 40],
                            csvGroupBy: "category",

                            totalColumnNames: ["totalCost", "marketValue", "estAnnualIncome", "estFrankingCredits", "estAnnualGrossIncome", "estGrossYield"],
                            totalDisplayNames: ["Total Cost", "Total Market Value", "Est.Annual Income", "Est.Annual Franking Credit", "Est.Annual Gross Income", "Est.Annual Gross Yield"],
                            totalColumnWidths: ["*", "*", "*", "*", "*", "*"]

                            csvTotalColumnNames: ["","","","","","totalCost", "marketValue", "profitOrLoss", "estAnnualIncome", "estFrankingCredits", "estAnnualGrossIncome", "estGrossYield"],
                            csvTotalDisplayNames: ["","","","","","Total Cost", "Total Market Value", "Profit (Loss)", "Historic Income",  "Historic Franking Credits", "Historic Gross Income", "Historic Gross Yield"],

                        }
                        return result
                    }else{
                        const result = {
                            columnNames: ["code", "securityName", "quantity", "costPrice", "totalCost", "price", "marketValue","profitOrLoss", "pctAssets"],
                            displayNames: [
                              "Code",
                              "Security Name",
                              "Quantity",
                              "Cost Price",
                              "Reduced Cost Base",
                              "Market Price",
                              "Market Value",
                              "Profit (Loss)",  
                              "Pct. Assets",
                            ],
                            displayNamesInternational: [
                                "Code",
                                "Currency",
                                "Name",
                                "Quantity",
                                "Native Cost Price",
                                "Native Total Cost",
                                "Native Market Price",
                                "Native Market Value",
                                "Native Profit (Loss)",
                                "AUD Total Cost",
                                "AUD Market Value",
                                "AUD Profit (Loss)",
                                "Pct. Assets",
                            ],

                            columnNamesInternational: [
                                "code",
                                "currency",
                                "securityName",
                                "quantity",
                                "nativeCostPrice",
                                "nativeTotalCost",
                                "nativeMarketPrice",
                                "nativeMarketValue",
                                "nativeProfitLoss",
                                "totalCost",
                                "marketValue",
                                "profitOrLoss",
                                "pctAssets"
                            ],

                            csvColumnNames: ["code", "securityName", "quantity", "costPrice", "totalCost", "price", "marketValue","profitOrLoss", "pctAssets"],
                            csvDisplayNames: ["Code", "Security Name", "Quantity", "Cost Price", "Reduced Cost Base", "Market Price", "Market Value","Profit (Loss)", "Pct. Assets"],
                            columnWidths: ["auto", "*", 50, 40, 60, 50, 60, 50, 40],
                            columnWidthsInternational: ["auto", "auto", "*", 40, 40, 50, 50, 50, 40, 50, 50, 40, 40],
                            csvGroupby: "category",

                            totalColumnNames: ["totalCost", "marketValue"],
                            totalDisplayNames: ["Total Cost", "Total Market Value"],
                            totalColumnWidths: ["*", "*",],

                            csvTotalColumnNames: ["","","","","","totalCost", "marketValue", "profitOrLoss", "estAnnualIncome"],
                            scvTotalDisplayNames: ["","","","","","Total Cost", "Total Market Value", "Profit (Loss)", "Historic Income"],

                        
                        }
                        return result
                    }
                case ReportType.StandardLedger:
                    return {
                        columnNames: ["ledgerDate", "description", "amount", "balance", "currency", "reference"],
                        /*displayNames: [
                          { text:"Date", alignment: 'left'},
                          { text:"Description", alignment: 'left'},
                          { text:"Amount", alignment: 'right'},
                          { text:"Balance", alignment: 'right'},
                          { text:"Currency", alignment: 'right'},
                          { text:"Reference", alignment: 'right'}
                        ],*/
                        displayNames: [
                          "Date",
                          "Description",
                          "Amount",
                          "Balance",
                          "Currency",
                          "Reference"
                        ],
                        csvColumnNames: ["ledgerDate", "description", "amount", "balance", "currency", "reference"],
                        csvDisplayNames: ["Date", "Description", "Amount", "Balance", "Currency", "Reference"],
                        columnWidths: ["auto", "*", "auto", "auto", "auto", "auto"]
                    }
                default:
                    console.error('Unrecognised report type encountered: ' + reportType);
                    return null;
            }
        }

        getCapitalTransactionStatement(doc) {
            var columnDefinitions = this.getColumnDefinitions(this.report.reportType);
            var headerCols = columnDefinitions.columnNames;
            var displayHeaderCols = columnDefinitions.displayNames;
            var widths = columnDefinitions.columnWidths;
            var statement = this.report as CapitalTransactionStatement;
            var transactions, footer, colspan = 1;
            if (statement && statement.tradeCategories && statement.tradeCategories.length > 0) {
                var categories = statement.tradeCategories;
                for (var i = 0; i < categories.length; i++) {
                    var category = categories[i];
                    doc.content.push(<any>this.headerRow(category.name));
                    transactions = category.transactions;
                    footer = category.subtotal;
                    footer.tradeDate = null;
                    footer.settlementDate = null;
                    footer.quantity = 'n/a';
                    footer.unitPrice = 'n/a';

                    doc.content.push(<any>this.table(transactions, headerCols, displayHeaderCols, widths, null, colspan, footer));
                }
            }
            return doc;
        }

        getCapitalGainsReport(doc) {
            var columnDefinitions = this.getColumnDefinitions(this.report.reportType);

            var headerCols = columnDefinitions.columnNames;
            var displayHeaderCols = columnDefinitions.displayNames;
            var widths = columnDefinitions.columnWidths;
            var report = this.report as RealisedCapitalGainsReport;
            var footer, colspan = 1;
            if (report && report.assetClasses.length > 0) {
                var assetClasses = report.assetClasses as RealisedCapitalGainsAssetClass[];

                for (var i = 0; i < assetClasses.length; i++) {
                    var assetClass = assetClasses[i] as RealisedCapitalGainsAssetClass;
                    doc.content.push(<any>this.headerRow(assetClass.name));
                    // AE: Capital Gains Report header row fix
                    doc.content.push(<any>this.table(null, headerCols, displayHeaderCols, widths, null, colspan, null));
                    var assets = assetClass.assets as RealisedCapitalGainsAsset[];
                    for (var j = 0; j < assets.length; j++) {
                        var asset = assets[j] as RealisedCapitalGainsAsset;
                        doc.content.push(<any>this.subHeaderRow(asset.name));
                        footer = asset.subtotal;
                        footer.purchaseDate = null;

                        footer.saleDate = null;
                        doc.content.push(<any>this.table(asset.capitalGains, headerCols, null, widths, null, colspan, footer));
                    }

                    footer = assetClass.subtotal;


                    footer.purchaseDate = null;
                    footer.saleDate = null;
                    footer.quantity = null;
                    doc.content.push(<any>this.subTotalTable(null, headerCols, null, widths, 'Sub Total', colspan, footer));
                }
                footer = report.total;
                footer.purchaseDate = null;
                footer.saleDate = null;
                footer.quantity = null;
                doc.content.push(<any>this.totalTable(null, headerCols, null, widths, 'Total', colspan, footer));
            }
            return doc;
        }
        getUnrealisedCapitalGainsReport(doc) {
            var columnDefinitions = this.getColumnDefinitions(this.report.reportType);
            var headerCols = columnDefinitions.columnNames;
            var displayHeaderCols = columnDefinitions.displayNames;
            var widths = columnDefinitions.columnWidths;
            var report = this.report as UnrealisedCapitalGainsReport;
            var footer, colspan = 1;
            if (report && report.assetClasses.length > 0) {
                var assetClasses = report.assetClasses as UnrealisedCapitalGainsAssetClass[];
                for (var i = 0; i < assetClasses.length; i++) {
                    var assetClass = assetClasses[i] as UnrealisedCapitalGainsAssetClass;
                    doc.content.push(<any>this.headerRow(assetClass.name));
                    // AE: Unreleased Capital Gains headers row fix
                    doc.content.push(<any>this.table(null, headerCols, displayHeaderCols, widths, null, colspan, null));
                    var assets = assetClass.assets as UnrealisedCapitalGainsAsset[];
                    for (var j = 0; j < assets.length; j++) {
                        var asset = assets[j] as UnrealisedCapitalGainsAsset;
                        doc.content.push(<any>this.subHeaderRow(asset.name));
                        footer = asset.subtotal;
                        footer.purchaseDate = null;
                        doc.content.push(<any>this.table(asset.capitalGains, headerCols, null, widths, null, colspan, footer));
                    }
                    footer = assetClass.subtotal;
                    footer.purchaseDate = null;
                    footer.quantity = 'n/a';
                    footer.marketValue = 'n/a';
                    footer.indexedCostBase = 'n/a';
                    footer.discountedCostBase = 'n/a';
                    footer.indexedGain = 'n/a';
                    doc.content.push(<any>this.subTotalTable(null, headerCols, null, widths, 'Sub Total', colspan, footer));
                }
                footer = report.total;
                footer.purchaseDate = null;
                footer.quantity = 'n/a';
                footer.marketValue = 'n/a';
                footer.indexedCostBase = 'n/a';
                footer.discountedCostBase = 'n/a';
                footer.indexedGain = 'n/a';
                doc.content.push(<any>this.totalTable(null, headerCols, null, widths, 'Total', colspan, footer));
            }
            return doc;
        }
        getPerformanceReport(doc) {
            var columnDefinitions = this.getColumnDefinitions(this.report.reportType);
            var report = this.report as PerformanceReport;
            if (!report) {
                return null;
            }
            var columnNames = columnDefinitions.columnNames;
            var displayNames = columnDefinitions.displayNames;
            var performanceTable = {
                table: {
                    widths: columnDefinitions.columnWidths,
                    headerRows: 0,
                    body: []
                },
                layout: this.getPerformanceLayout() //this.layoutThinLightBorder()
            }
            doc.content.push(<any>this.headerRow("Performance"));

            for (var i = 0; i < columnNames.length; i++) {
                var displayName = displayNames[i];
                var item = columnNames[i];
                var value = this.currencyFormatted(report[item]);
                if (i == 0 || i > columnNames.length-3){
                  performanceTable.table.body.push([
                    { text: displayName, border: [false, false, false, true], style: this.pdfBuilder.styles.tableCellBold },
                    { text: value, alignment: 'right', border: [false, false, false, true], style: this.pdfBuilder.styles.tableCellBold }
                  ]);
                } else {
                  performanceTable.table.body.push([
                    { text: displayName, border: [false, false, false, true], style: this.pdfBuilder.styles.tableCell },
                    { text: value, alignment: 'right', border: [false, false, false, true], style: this.pdfBuilder.styles.tableCell }
                  ]);
                }
            }
            doc.content.push(performanceTable);
            return doc;
        }
        capitalizeFirstLetter(string) {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }
        // Holdings report


       handleLongString(category){
                 category.items.forEach((x,index)=>{
                                            let words = x.securityName.split(" ");
                                            let code = x.code.split(/[_\s]+/);

                                              // split the words into subwords

                                            for (let i = 0; i < words.length; i++) {
                                              if (words[i].length > 5) {
                                                words[i] = words[i].substring(0, 5) + " " + words[i].substring(5);
                                              }
                                            }
                  for (let i = 0; i < code.length; i++) {
                                              if (code[i].length > 3) {
                                                code[i] = code[i].substring(0, 3) + " " + code[i].substring(3);
                                              }
                                            }
                                            let newCode = code.join(" ");
                                            category.items[index].code =newCode;
                                            let newSentence = words.join(" ");
                                            category.items[index].securityName =newSentence
                                            } 
                            
                                  //  split the code  into two codes
                
                    );
                    }

        getValuationStatement(doc) {
            let columnDefinitions = this.getColumnDefinitions(this.report.reportType);
            let headerCols = columnDefinitions.columnNames;
            let headerColsInternational = columnDefinitions.columnNamesInternational;
            let displayHeaderCols = columnDefinitions.displayNames;
            let displayHeaderColsInternational = columnDefinitions.displayNamesInternational;
            let widths = columnDefinitions.columnWidths;
            let widthsInternational = columnDefinitions.columnWidthsInternational;
            let valuationStatement = this.report as ValuationStatement;
            let tableBody: any[] = [];

            // Non-LOA securities
            if (valuationStatement.nonLoaSecurities) {
                let categories = valuationStatement.nonLoaSecurities as AssetCategory[];
                for (let i = 0; i < categories.length; i++) {
                    let category = categories[i];
                    this.handleLongString(category);
                    tableBody = [];
                    if(category.categoryName.includes("International")){
                        tableBody.push(this.getHoldingsHeaderRow(displayHeaderColsInternational));
                        tableBody.push(this.formatSubheadingRow(category.categoryName, headerColsInternational.length));
                        let lineItems = this.formatDataForPdf(category.items);
                        let footer = this.formatDataForPdf(category.subtotal);
                        tableBody = tableBody.concat(this.buildTableBody(lineItems, headerColsInternational, null, null, 0, footer));
                        doc.content.push(<any>this.tableWithHeader(tableBody, headerColsInternational, widthsInternational));
                    }else{
                        tableBody.push(this.getHoldingsHeaderRow(displayHeaderCols));
                        tableBody.push(this.formatSubheadingRow(category.categoryName, headerCols.length));
                        let lineItems = this.formatDataForPdf(category.items);
                        let footer = this.formatDataForPdf(category.subtotal);
                        tableBody = tableBody.concat(this.buildTableBody(lineItems, headerCols, null, null, 0, footer));
                        doc.content.push(<any>this.tableWithHeader(tableBody, headerCols, widths));

                    }
                }
            }

            // Non-LOA unsettled dividends
            if (valuationStatement.nonLoaUnsettledDividends) {
                let dividends = valuationStatement.nonLoaUnsettledDividends;
                if (dividends.items && dividends.items.length > 0) {
                    tableBody = []
                    tableBody.push(this.getHoldingsHeaderRow(displayHeaderCols));
                    tableBody.push(this.formatSubheadingRow("Unsettled Dividends", headerCols.length));
                    let lineItems = this.formatDataForPdf(dividends.items);
                    let footer = this.formatDataForPdf(dividends.subtotal);
                    tableBody = tableBody.concat(this.buildTableBody(lineItems, headerCols, null, null, 0, footer));
                    doc.content.push(<any>this.tableWithHeader(tableBody, headerCols, widths));
                }
            }

            // LOA securities
            if (valuationStatement.loaSecurities) {
                let categories = valuationStatement.loaSecurities as AssetCategory[];
                for (let i = 0; i < categories.length; i++) {
                    tableBody = [];
                    let category = categories[i];
                    this.handleLongString(category);
                    tableBody.push(this.getHoldingsHeaderRow(displayHeaderCols));
                    tableBody.push(this.formatSubheadingRow(category.categoryName, headerCols.length));
                    let lineItems = this.formatDataForPdf(category.items);
                    let footer = this.formatDataForPdf(category.subtotal);
                    tableBody = tableBody.concat(this.buildTableBody(lineItems, headerCols, null, null, 0, footer));
                    doc.content.push(<any>this.tableWithHeader(tableBody, headerCols, widths));
                }
            }

            // LOA unsettled dividends
            if (valuationStatement.loaUnsettledDividends) {
                let dividends = valuationStatement.loaUnsettledDividends;
                if (dividends.items && dividends.items.length > 0) {
                    tableBody = [];
                    tableBody.push(this.getHoldingsHeaderRow(displayHeaderCols));
                    tableBody.push(this.formatSubheadingRow("Unsettled Dividends", headerCols.length));
                    let lineItems = this.formatDataForPdf(dividends.items);
                    let footer = this.formatDataForPdf(dividends.subtotal);
                    tableBody = tableBody.concat(this.buildTableBody(lineItems, headerCols, null, null, 0, footer));
                    doc.content.push(<any>this.tableWithHeader(tableBody, headerCols, widths));
                }
            }
            if(valuationStatement.managedAccounts){
                Object.keys(valuationStatement.managedAccounts).forEach(key => {
                    if (valuationStatement.managedAccounts[key].items.length) {
                        let categories = valuationStatement.managedAccounts[key].items as AssetCategory[];
                        tableBody = []
                        tableBody.push(this.getHoldingsHeaderRow(displayHeaderCols));
                        tableBody.push(this.formatSubheadingRow(this.capitalizeFirstLetter(key), headerCols.length));
                        for (let i = 0; i < categories.length; i++) {
                            let category = categories[i];
                            this.handleLongString(category);
                            tableBody.push(this.formatNestedSubheadingRow(category.categoryName, headerCols.length));
                            let lineItems = this.formatDataForPdf(category.items);
                            let footer = this.formatDataForPdf(category.subtotal);
                            tableBody = tableBody.concat(this.buildTableBody(lineItems, headerCols, null, null, 0, footer));
                        }
                        doc.content.push(<any>this.tableWithHeader(tableBody, headerCols, widths, displayHeaderCols));
                    }
    
                })
            }
            // doc.content.push(<any>this.tableWithHeader(tableBody, headerCols, widths, displayHeaderCols));

            // Grand totals
            if (valuationStatement.grandTotal) {
                let total = [];
                total.push(valuationStatement.grandTotal);
                doc.content.push(<any>this.headerRow("Grand Totals"));
                doc.content.push(<any>this.table(total, columnDefinitions.totalColumnNames, columnDefinitions.totalDisplayNames, columnDefinitions.totalColumnWidths, null, 0, null));
            }

            return doc;
        }
        getQuarterlyReportsReport(doc) {
            let columnDefinitions = this.getColumnDefinitions(this.report.reportType);
            let headerCols = columnDefinitions.columnNames;
            let displayHeaderCols = columnDefinitions.displayNames;
            let widths = columnDefinitions.columnWidths;
            let quarterlyReport = this.report as QuarterlyReportsListReport;
            let colspan = 1;
            if (quarterlyReport && quarterlyReport.investorDocs && quarterlyReport.investorDocs.length > 0) {
                doc.content.push(<any>this.table(quarterlyReport.investorDocs,
                    headerCols,
                    displayHeaderCols,
                    widths,
                    null,
                    colspan,
                    null));
            }
            return doc;
        }
        getTaxReportsReport(doc) {
            let columnDefinitions = this.getColumnDefinitions(this.report.reportType);
            let headerCols = columnDefinitions.columnNames;
            let displayHeaderCols = columnDefinitions.displayNames;
            let widths = columnDefinitions.columnWidths;
            let taxReport = this.report as TaxReportsListReport;
            let colspan = 1;
            if (taxReport && taxReport.investorDocs && taxReport.investorDocs.length > 0) {
                doc.content.push(<any>this.table(taxReport.investorDocs,
                    headerCols,
                    displayHeaderCols,
                    widths,
                    null,
                    colspan,
                    null));
            }
            return doc;
        }
        getCashReport(doc) {
            var columnDefinitions = this.getColumnDefinitions(this.report.reportType);
            var headerCols = columnDefinitions.columnNames;
            var displayHeaderCols = columnDefinitions.displayNames;
            var widths = columnDefinitions.columnWidths;
            var cashReport = this.report as CashReport;
            var transactions, footer, colspan = 1;
            if (cashReport && cashReport.transactionGroups && cashReport.transactionGroups.length > 0) {
                var groups = cashReport.transactionGroups;
                for (var i = 0; i < groups.length; i++) {
                    var group = groups[i];
                    doc.content.push(<any>this.headerRow(group.name));
                    transactions = group.transactions;
                    footer = group.closingBalance;
                    doc.content.push(<any>this.table(transactions, headerCols, displayHeaderCols, widths, null, colspan, footer));
                }
            }
            return doc;
        }
        getIncomeReport(doc) {
            var columnDefinitions = this.getColumnDefinitions(this.report.reportType);
            var headerCols = columnDefinitions.columnNames;
            var displayHeaderCols = columnDefinitions.displayNames;
            var widths = columnDefinitions.columnWidths;
            var incomeReport = this.report as IncomeReport;
            var categories: TransactionTypeCategory[];
            var subCategories: TransactionTypeSubCategory[];
            var footer: IncomeReportLineItem;
            var colspan = 4;

            if (incomeReport && incomeReport.transactionTypeCategories && incomeReport.transactionTypeCategories.length > 0) {
                var categories = incomeReport.transactionTypeCategories;
                for (var cat = 0; cat < categories.length; cat++) {
                    var category = categories[cat];
                    doc.content.push(<any>this.headerRow(category.name));
                    doc.content.push(<any>this.tableWithHeader(null, columnDefinitions, widths, displayHeaderCols));
                    for (var subCat = 0; subCat < category.subCategories.length; subCat++) {
                        var subCategory = category.subCategories[subCat];
                        if (subCategory.name != category.name) {
                            doc.content.push(<any>this.subHeaderRow(subCategory.name));
                        }
                        var lineItems = subCategory.lineItems;
                        doc.content.push(<any>this.table(lineItems, headerCols, null, widths, null, null, null));
                    }

                    footer = category.subtotal;
                    footer.payDate = null;
                    footer.exDate = null;
                    footer.code = null;
                    footer.description = null;
                    doc.content.push(<any>this.table(null, headerCols, null, widths, "TOTAL " + category.name.toUpperCase(), colspan, footer));
                }

                if (incomeReport && incomeReport.grandTotal) {
                    footer = incomeReport.grandTotal;
                    footer.payDate = null;
                    footer.exDate = null;
                    footer.code = null;
                    footer.description = null;

                    doc.content.push(<any>this.table(null, headerCols, null, widths, "INCOME LESS EXPENSES:", colspan, footer));
                }
            }

            return doc;
        }

        getStandardLedger(doc) {
            var columnDefinitions = this.getColumnDefinitions(this.report.reportType);
            var headerCols = columnDefinitions.columnNames;
            var displayHeaderCols = columnDefinitions.displayNames;
            var widths = columnDefinitions.columnWidths;
            var colspan = 1;

            var standardLedgerReport = this.report as StandardLedgerReport;
            if (standardLedgerReport &&
                standardLedgerReport.ledgerEntries &&
                standardLedgerReport.ledgerEntries.length > 0) {
                var entries = standardLedgerReport.ledgerEntries;
                doc.content.push(<any>this.headerRow("Ledger"));
                doc.content.push(<any>this.ledgerTable(entries, headerCols, displayHeaderCols, widths, null, colspan, null));
            }

            return doc;
        }

        formatDataForPdf(data) {
            if (!data) return null;
            var pdfData = angular.copy(data);
            if (pdfData instanceof Array) {
                pdfData.map((item) => {
                    this.formatDataRow(item);
                });
            } else {
                this.formatDataRow(pdfData);
            }
            return pdfData;
        }

        formatDataRow(item) {
            if (item == null || item === undefined) return null;
            switch (this.report.reportType) {
                case ReportType.CapitalTransactions:
                    item.tradeDate = this.dateFormatted(item.tradeDate);
                    item.settlementDate = this.dateFormatted(item.settlementDate);
                    item.quantity = this.currencyFormatted(item.quantity);
                    item.unitPrice = this.currencyFormatted(item.unitPrice);
                    item.grossAmount = this.currencyFormatted(item.grossAmount);
                    item.brokerage = this.currencyFormatted(item.brokerage);
                    item.gst = this.currencyFormatted(item.gst);
                    item.netAmount = this.currencyFormatted(item.netAmount);
                    break;
                case ReportType.QuarterlyReports:
                    break;
                case ReportType.Cash:
                    item.date = this.dateFormatted(item.date);
                    item.debit = this.currencyFormatted(this.absoluteValue(item.debit));
                    item.credit = this.currencyFormatted(item.credit);
                    item.balance = this.currencyFormatted(item.balance);
                    break;
                case ReportType.Income:
                    item.payDate = this.dateFormatted(item.payDate);
                    item.exDate = this.dateFormatted(item.exDate);
                    item.amount = this.currencyFormatted(item.amount);
                    item.frankingCredits = this.currencyFormatted(item.frankingCredits);
                    item.withholdingTax = this.currencyFormatted(item.withholdingTax);
                    item.gst = this.currencyFormatted(item.gst);
                    break;
                case ReportType.CapitalGains:
                    item.purchaseDate = this.dateFormatted(item.purchaseDate);
                    item.saleDate = this.dateFormatted(item.saleDate);
                    item.quantity = this.integerFormatted(item.quantity);
                    item.costPrice = this.currencyFormatted(item.costPrice);
                    item.totalCost = this.currencyFormatted(item.totalCost);
                    item.reducedCostBase = this.currencyFormatted(item.reducedCostBase);
                    item.indexedCostBase = this.currencyFormatted(item.indexedCostBase);
                    item.discountedCostBase = this.currencyFormatted(item.discountedCostBase);
                    item.capitalLoss = this.currencyFormatted(item.capitalLoss);
                    item.indexedGain = this.currencyFormatted(item.indexedGain);
                    item.grossDiscountGain = this.currencyFormatted(item.grossDiscountGain);
                    item.salePrice = this.currencyFormatted(item.salePrice);
                    item.otherGain = this.currencyFormatted(item.otherGain);
                    item.capitalProceeds = this.currencyFormatted(item.capitalProceeds);
                    break;
                case ReportType.UnrealisedCapitalGains:
                    item.purchaseDate = this.dateFormatted(item.purchaseDate);
                    item.quantity = this.integerFormatted(item.quantity);
                    item.costPrice = this.currencyFormatted(item.costPrice);
                    item.totalCost = this.currencyFormatted(item.totalCost);
                    item.reducedCostBase = this.currencyFormatted(item.reducedCostBase);
                    item.indexedCostBase = this.currencyFormatted(item.indexedCostBase);
                    item.discountedCostBase = this.currencyFormatted(item.discountedCostBase);
                    item.capitalLoss = this.currencyFormatted(item.capitalLoss);
                    item.indexedGain = this.currencyFormatted(item.indexedGain);
                    item.grossDiscountGain = this.currencyFormatted(item.grossDiscountGain);
                    item.otherGain = this.currencyFormatted(item.otherGain);
                    item.marketPrice = this.currencyFormatted(item.marketPrice);
                    item.marketValue = this.currencyFormatted(item.marketValue);
                    break;
                case ReportType.Performance:
                    break;
                case ReportType.TaxReports:
                    break;
                case ReportType.Valuation:
                    if (item.hasOwnProperty("unsettledIncome")) {
                        item.code = item.securityCode;
                        item.marketValue = this.currencyFormatted(item.unsettledIncome);
                    } else {
                        item.quantity = this.currencyFormatted(item.quantity);
                        item.costPrice = this.formatAsCurrency4DecPts(item.costPrice);
                        item.totalCost = this.currencyFormatted(item.totalCost);
                        item.price = this.formatAsCurrency4DecPts(item.price);
                        item.marketValue = this.currencyFormatted(item.marketValue);
                        item.profitOrLoss = this.currencyFormatted(item.profitOrLoss);
                        item.pctAssets = this.percentFormatted(item.pctAssets);
                        item.estAnnualIncome = this.currencyFormatted(item.estAnnualIncome);
                        item.estAnnualGrossIncome = this.currencyFormatted(item.estAnnualGrossIncome);
                        item.estFrankingCredits = this.currencyFormatted(item.estFrankingCredits);
                        item.estGrossYield = this.percentFormatted(item.estGrossYield);

                        item.nativeCostPrice = this.currencyFormatted(item.nativeCostPrice);
                        item.nativeTotalCost = this.currencyFormatted(item.nativeTotalCost);
                        item.nativeMarketPrice = this.currencyFormatted(item.nativeMarketPrice);
                        item.nativeMarketValue = this.currencyFormatted(item.nativeMarketValue);
                        item.nativeProfitLoss = this.currencyFormatted(item.nativeProfitLoss);
                    }
                    break;
                case ReportType.StandardLedger:
                    item.ledgerDate = this.dateFormatted(item.ledgerDate);
                    item.amount = this.currencyFormatted(item.amount);
                    item.balance = this.currencyFormatted(item.balance);
                    item.isCancelled = IdMgr.YesNo()(item.isCancelled);
                    item.isOpen = IdMgr.YesNo()(item.isOpen);
                    break;
                default:
                    console.error('Unrecognised report type encountered: ' + this.report.reportType);
                    return null;
            }
            return item;
        }

        dateFormatted(date: Date) {
            return date ? moment(date).format("DD-MM-YYYY") : null;
        }

        getPdfTemplateDefinition() {
            var deferred = this.q.defer();
                
                let timestamp = moment.tz(this.report.creationDateUtc, 'Australia/Sydney').format("h:mm a [AEST on] D MMM YYYY");
                let reportTitle = this.report.title;
                //let adviserName = this.account.adviserName ? this.account.adviserName : "";
                //let dateHeading: any[] = this.buildDateHeading(this.report.asAtDate, this.report.dateFrom, this.report.dateTo);
                let docDefinition = {
                    pageSize: 'A4',
                    pageOrientation: 'landscape',
                    pageMargins: [ 56, 28, 56, 60 ],
                    content: [
                        this.pdfBuilder.getImageContent(),
                        {
                            text: reportTitle,
                            style: this.pdfBuilder.styles.header,
                            margin: [0, 0, 0, 0]
                        },
                        {
                            text: this.filter<any>("accountName")(this.account.designation ? this.account.accountName+' '+this.account.designation : this.account.accountName),
                            style: this.pdfBuilder.styles.subHeader,
                            margin: [0, 5, 0, 10]
                        },
                        this.buildHeadingTable(this.report.asAtDate, this.report.dateFrom, this.report.dateTo),
                    ],
                    footer: this.pdfBuilder.docDefinition.footer,
                    styles: {
                        header: {
                            fontSize: 16,
                            bold: false,
                            margin: [5, 5, 0, 10]
                        },
                        headerText: {
                            margin: [5, 5, 5, 5]
                        },
                        lastHeaderText: {
                            margin: [5, 5, 5, 15]
                        },
                        tableHeader: {
                            fontSize: 8,
                            bold: true,
                            alignment: 'center',
                            fillColor: '#dadada',
                            margin: [5, 5, 0, 10]
                        },
                        filledHeader: {
                            bold: true,
                            fontSize: 8,
                            color: 'white',
                            fillColor: this.pdfBuilder.userCompany.colorSecondary,
                            margin: [10, 2, 2, 2],
                        },
                        filledHoldingsHeader: {
                            bold: true,
                            fontSize: 8,
                            color: 'white',
                            fillColor: '#dadada',
                            margin: [10, 2, 2, 2],
                        },
                        secondaryHeader: {
                            bold: true,
                            fontSize: 8,
                            color: 'black',
                            alignment: 'left'
                        },
                        footerRow: {
                            bold: true,
                            fontSize: 8,
                            margin: [0, 2, 2, 2]
                        },
                        footerText: {
                        fontSize: 5,
                        bold: false,
                        alignment: 'center'
                        }
                    }
                };
                deferred.resolve(docDefinition);
            return deferred.promise;
        }
        appendSpannedCells(row: any[], span: number): any[] {
            // For a colspanning cell, we must still define the empty cells.
            for (let i = 1; i < span; i++) {
                row.push({border: [false, false, false, false]});
            }
            return row;
        }


        formatNestedSubheadingRow(label: string, colspan: number) {
            let row: any[] = [];
            row.push({
              border: [false, false, false, false],
              text: label,
              colSpan: colspan,
              style: this.pdfBuilder.styles.filledSubHeader,
              margin: [0, 5, 5, 5],
              alignment: 'left' });
            this.appendSpannedCells(row, colspan);
            return row;
        }

        formatSubheadingRow(label: string, colspan: number) {
            let row: any[] = [];
            row.push({
              border: [false, false, false, false],
              text: label,
              colSpan: colspan,
              style: this.pdfBuilder.styles.filledHeader,
              margin: [0, 5, 5, 5],
              alignment: 'left' });
            this.appendSpannedCells(row, colspan);
            return row;
        }

        headerRow(label: string) {
            return {
                table: {
                    widths: ['*'],
                    body: [
                      [
                        {
                           border: [false, false, false, false],
                           text: label,
                           style: this.pdfBuilder.styles.filledHeader,
                           margin: [5, 2, 2, 2]
                         }
                       ]
                     ]
                },
                layout: 'noBorders'
            };
        }

        subHeaderRow(label: string) {
            return {
                table: {
                    widths: ['*'],
                    body: [[{ text: label, style: 'secondaryHeader', margin: [5,2,2,2] }]]
                },
                layout: 'noBorders'
            };
        }

        // if footerLabel - Sub Total
        table(transactions, columns, headers, widths, footerLabel, footerLabelColspan, footerData) {
            var data = this.formatDataForPdf(transactions);
            var footer = this.formatDataForPdf(footerData);
            return {
                fontSize: 8,
                table: {
                    widths: widths,
                    headerRows: 0,
                    body: this.buildTableBody(data, columns, headers, footerLabel, footerLabelColspan, footer)
                },
                layout: (headers) ? this.getTablelayout(false, false, true, false) : this.getTablelayout(false, false, false, false)//(headers) ? this.layoutThinLightBorderHeader() : this.layoutThinLightBorder()
            };
        }

        // if footerLabel - Sub Total
        ledgerTable(transactions, columns, headers, widths, footerLabel, footerLabelColspan, footerData) {
            var data = this.formatDataForPdf(transactions);
            var footer = this.formatDataForPdf(footerData);
            return {
                fontSize: 8,
                table: {
                    widths: widths,
                    headerRows: 0,
                    body: this.buildTableBody(data, columns, headers, footerLabel, footerLabelColspan, footer)
                },
                layout: this.getTablelayout(false, false, false, false, true)
            };
        }

        // if footerLabel - Sub Total
        subTotalTable(transactions, columns, headers, widths, footerLabel, footerLabelColspan, footerData) {
            var data = this.formatDataForPdf(transactions);
            var footer = this.formatDataForPdf(footerData);
            return {
                fontSize: 8,
                table: {
                    widths: widths,
                    headerRows: 0,
                    body: this.buildSubTotalTableBody(data, columns, headers, footerLabel, footerLabelColspan, footer)
                },
                layout: this.getTablelayout(true, false, false, false)
            };
        }

        // if footerLabel - Sub Total
        totalTable(transactions, columns, headers, widths, footerLabel, footerLabelColspan, footerData) {
            var data = this.formatDataForPdf(transactions);
            var footer = this.formatDataForPdf(footerData);
            return {
                fontSize: 8,
                table: {
                    widths: widths,
                    headerRows: 0,
                    body: this.buildSubTotalTableBody(data, columns, headers, footerLabel, footerLabelColspan, footer)
                },
                layout: this.getTablelayout(false, true, false, false)
            };
        }

        tableWithHeader(bodyRows: any[], columns: any, columnWidths: any, headers: any) {
            let isHoldings = false;
            let tableBody: any[] = [];
            if (bodyRows) {
                isHoldings = true;
                for (var i = 0; i < bodyRows.length; i++){
                  tableBody.push(bodyRows[i]);
                }
            }
            // fix for income and expenses report (body rows is null)
            else{
              if (headers) {
                  tableBody.push(this.getHeaderRow(headers));
              }
            }
            return {
                fontSize: 8,
                table: {
                    widths: columnWidths,
                    headerRows: 1,
                    body: tableBody
                },
                margin: isHoldings ? [0,0,0,10] : [],
                layout: (isHoldings) ?
                   this.getTablelayout(false, false, false, true) :
                  this.getTablelayout(false, false, true, false)
            };
        }

        buildHeadingTable(asAtDate: Date, dateFrom: Date, dateTo: Date){
          let headingTable = {
            style: { fontSize: 8 },
            margin: [-4, 8, 0, 5],
            table: {
              widths: ['auto', '*', 'auto', 'auto'],
              body: []
            }
          };

          headingTable.table.body.push([
            { border: [false, false, false, false], text: 'Adviser: ', style: { bold: true, alignment: 'left' } },
            { border: [false, false, false, false], text: this.account.adviserName ? this.account.adviserName : "", style: { bold: false, alignment: 'left', fontSize: 8 } },
            { border: [false, false, false, false], text: '', style: { bold: true, alignment: 'right', fontSize: 8 } },
            { border: [false, false, false, false], text: '', style: { bold: false, alignment: 'right', fontSize: 8 } }
          ]);

          headingTable.table.body.push([
            { border: [false, false, false, false], text: 'Account No: ', style: { bold: true, alignment: 'left', fontSize: 8 } },
            { border: [false, false, false, false], text: this.account.accountId, style: { bold: false, alignment: 'left', fontSize: 8 } },
            { border: [false, false, false, false], text: '', style: { bold: true, alignment: 'right', fontSize: 8 } },
            { border: [false, false, false, false], text: '', style: { bold: false, alignment: 'right', fontSize: 8 } }
          ]);

          if (!asAtDate) {
            headingTable.table.body.push(
              [
                { border: [false, false, false, false], text: 'From Date: ', style: { bold: true, alignment: 'left', fontSize: 8 } },
                { border: [false, false, false, false], text: moment(dateFrom).format("YYYY-MM-DD"), style: { bold: false, alignment: 'left', fontSize: 8 } },
                { border: [false, false, false, false], text: '', style: { bold: true, alignment: 'right', fontSize: 8 } },
                { border: [false, false, false, false], text: '', style: { bold: false, alignment: 'right', fontSize: 8 } }
              ]);
            headingTable.table.body.push(
              [
                { border: [false, false, false, false], text: 'To Date: ', style: { bold: true, alignment: 'left', fontSize: 8 } },
                { border: [false, false, false, false], text: moment(dateTo).format("YYYY-MM-DD"), style: { bold: false, alignment: 'left', fontSize: 8 } },
                { border: [false, false, false, false], text: '', style: { bold: true, alignment: 'right', fontSize: 8 } },
                { border: [false, false, false, false], text: '', style: { bold: false, alignment: 'right', fontSize: 8 } }
              ]);
          }

          headingTable.table.body.push([
            { border: [false, false, false, false], text: 'Report Generated At: ', style: { bold: true, alignment: 'left', fontSize: 8 } },
            { border: [false, false, false, false], text: moment.tz(new Date(), 'Australia/Sydney').format('h:mm a [AEST on] D MMM YYYY'), style: { bold: false, alignment: 'left', fontSize: 8 } },
            { border: [false, false, false, false], text: (asAtDate) ? 'As at:' : '', style: { bold: true, alignment: 'right', fontSize: 8 } },
            { border: [false, false, false, false], text: (asAtDate) ? moment(asAtDate).tz('Sydney/Australia').format("D MMM YYYY hh:mm:ss A [AEST]") : '', style: { bold: false, alignment: 'right', fontSize: 8.5 } }
          ]);

          return headingTable;
        }

        // footerLabel - Sub Total
        buildTableBody(data, columns, headers, footerLabel, footerLabelColspan, footerData) {
            var body = [];
            if (headers) {
                body.push(this.getHeaderRow(headers));
            }
            if (data) {
                data.forEach(row => {
                    var dataRow = this.getRow(row, columns);
                    body.push(dataRow);
                });
            }
            if (footerData) {
                body.push(this.getFooterRow(footerLabel, columns, footerLabelColspan, footerData));
            }
            return body;
        }

        // footerLabel - Sub Total
        buildSubTotalTableBody(data, columns, headers, footerLabel, footerLabelColspan, footerData) {
            var body = [];
            if (headers) {
                body.push(this.getHeaderRow(headers));
            }
            if (data) {
                data.forEach(row => {
                    var dataRow = this.getSubTotalRow(row, columns);
                    body.push(dataRow);
                });
            }
            if (footerData) {
                body.push(this.getSubTotalFooterRow(footerLabel, columns, footerLabelColspan, footerData));
            }
            return body;
        }

        isNumericHeader(header){
          var numericHeaders = [
            'Quantity',
            'Price',
            'Cost',
            'Value',
            'Assets',
            'Income',
            'Credit',
            'Debit',
            'Balance',
            'Yield',
            'Amount',
            'Brokerage',
            'GST',
            'Tax',
            'Capital',
            'Gain',
            'Loss'
          ];
          return numericHeaders.some(function(v) { return header.indexOf(v) >= 0; });
        }

        getHeaderRow(headers) {
            var formattedHeaders = [];
            if (headers) {
                for (var h = 0; h < headers.length; h++) {
                    formattedHeaders.push({
                      border: [false, false, false, true],
                      text: headers[h],
                      style: this.pdfBuilder.styles.tableHeader,
                      alignment: this.isNumericHeader(headers[h]) ? 'right' : 'left'
                    }
                  );
                }
            }
            return formattedHeaders;
        }

        getHoldingsHeaderRow(headers) {
            var formattedHeaders = [];
            if (headers) {
                for (var h = 0; h < headers.length; h++) {
                    formattedHeaders.push({
                        border: [false, true, false, true],
                        text: headers[h],
                        style: this.pdfBuilder.styles.filledHoldingsHeader,
                        alignment: this.isNumericHeader(headers[h]) ? 'right' : 'left'
                    }
                    );
                }
            }
            return formattedHeaders;
        }

        getRow(data, columns) {
            var result = [];
            columns.forEach(column => {
                if (column && data[column]) {
                  const style =JSON.parse(JSON.stringify(this.pdfBuilder.styles.tableCell))
                  if(column === "profitOrLoss" || column === "nativeProfitLoss"){
                      const value = parseFloat(data[column]);
                      if(!isNaN(value)){
                          if(value != 0){
                              if (value > 0) {                               
                                style.fillColor = '#dff0d8';
                              }else{
                                style.fillColor = '#f2dede';    
                              }
                          }
                      }
                  }
                  result.push({
                    border: [false, false, false, true],
                    text: data[column].toString(),
                    style: style,
                    alignment: !isNaN(data[column].replace(/,/g, '').replace(/%/g, '')) ? 'right' : 'left'
                  });
                } else {
                    result.push({border: [false, false, false, true], text:''});
                }
            });
            return result; 
        }

        getSubTotalRow(data, columns) {
            var result = [];
            columns.forEach(column => {
                if (column && data[column]) {
                  result.push({
                    border: [false, true, false, false],
                    text: data[column].toString(),
                    style: this.pdfBuilder.styles.tableCell,
                    alignment: !isNaN(data[column].replace(/,/g, '').replace(/%/g, '')) ? 'right' : 'left'
                  });
                } else {
                    result.push({border: [false, true, false, false], text:''});
                }
            });
            return result;
        }

        getFooterRow(footerLabel, columns, footerColspan, footerData) {
            let workingColumns = angular.copy(columns);
            let result = [];
            if (footerLabel) {
                result = [{
                  text: footerLabel,
                  colSpan: footerColspan,
                  style: {bold: true},
                  alignment: 'left',
                  border: [false, false, false, false]
                }];
                delete workingColumns[0]; //this is to keep the same col count same as the rest of the table rows
            }
            if (!workingColumns || workingColumns.length <= 0) {
                return result;
            }
            workingColumns.forEach(column => {
                if (column && footerData[column]) {
                    result.push({
                      text: footerData[column].toString(),
                      style: {bold: true},
                      alignment: !isNaN(footerData[column].replace(/,/g, '').replace(/%/g, '')) ? 'right' : 'left',
                      margin: [0,0,0,0],
                      border: [false, true, false, false]
                    });
                } else {
                    result.push({ text: '', style: {bold: true}, border: [false, false, false, false] });
                }
            });
            return result;
        }

        getSubTotalFooterRow(footerLabel, columns, footerColspan, footerData) {
            let workingColumns = angular.copy(columns);
            let result = [];
            if (footerLabel) {
                result = [{
                  text: footerLabel,
                  colSpan: footerColspan,
                  style: 'footerRow',
                  alignment: 'left',
                  border: [false, true, false, false]
                }];
                delete workingColumns[0]; //this is to keep the same col count same as the rest of the table rows
            }
            if (!workingColumns || workingColumns.length <= 0) {
                return result;
            }
            workingColumns.forEach(column => {
                if (column && footerData[column]) {
                    result.push({
                      text: footerData[column].toString(),
                      style: 'footerRow',
                      alignment: !isNaN(footerData[column].replace(/,/g, '').replace(/%/g, '')) ? 'right' : 'left',
                      margin: [0,0,0,0],
                      border: [false, true, false, false]
                    });
                } else {
                    result.push({ text: '', style: 'footerRow', border: [false, true, false, false] });
                }
            });
            return result;
        }

        integerFormatted(amount): string {
            if (amount === 'n/a' || amount === '' || amount === null || amount === undefined) {
                return '';
            }
            let i: number = parseInt(amount);
            return this.addCommas(i.toString());
        }
        private formatAsCurrency4DecPts(amount: any): string {
            if (amount === 'n/a' || amount === '' || amount === null || amount === undefined) {
                return '';
            }
            return amount.toFixed(4).replace(/\d(?=(\d{3})+\.)/g, '$&,');

        }
        currencyFormatted(amount): string {
            if (amount === 'n/a' || amount === '' || amount === null || amount === undefined) {
                return '';
            }
            var i: number = parseFloat(amount);
            if (isNaN(i)) {
                i = 0.00;
            }
            var minus = '';
            if (i < 0) { minus = '-'; }
            i = Math.abs(i);
            i = parseInt(((i + .005) * 100).toString());
            i = i / 100;
            var s = i.toString();
            if (s.indexOf('.') < 0) { s += '.00'; }
            if (s.indexOf('.') === (s.length - 2)) { s += '0'; }
            s = minus + s;
            return this.addCommas(s);
        }
        addCommas(nStr): string {
            nStr = nStr + '';
            var x = nStr.split('.');
            var x1 = x[0];
            var x2 = x.length > 1 ? '.' + x[1] : '';
            var rgx = /(\d+)(\d{3})/;
            while (rgx.test(x1)) {
                x1 = x1.replace(rgx, '$1' + ',' + '$2');
            }
            return x1 + x2;
        }
        absoluteValue(amount: number): number {
            if (amount === null || amount === undefined) {
                return null;
            }
            return Math.abs(amount);
        }
        percentFormatted(amount: any) {
            let numberString: string = this.currencyFormatted(amount);
            return numberString + "%";
        }
        getFileName() {
            if (this.account == null) {
                return "";
            }
            if (this.report == null) {
                return "";
            }
            var accountId = this.account.accountId;
            var startDate = moment(this.report.dateFrom).format("YYYY-MM-DD");
            var endDate = moment(this.report.dateTo).format("YYYY-MM-DD");
            return accountId + "-" + this.report.reportType + "-" + startDate + "_" + endDate;
        }

        createCsvFile() {
            let nowDate = moment(new Date());
            let topLine = ReportDownloadService.getCsvTopLine(this.account, this.report.creationDateUtc, this.report.dateFrom, this.report.dateTo, this.report.asAtDate);
            var columnDefinition = this.getColumnDefinitions(this.report.reportType);
            var header = this.getCsvColumnHeadings();
            var columnNames = this.getCsvColumnNames();
            var data = this.getCsvData();
            var groupBy = columnDefinition.csvGroupBy

            let csvContent = [];

            let processCsvRows = function(rows){
                if(!rows){
                  return
                }
                for (var i = 0; i < rows.length; i++) {
                    var row = rows[i];
                    var rowItems = [];


                    for (var columnIndex = 0; columnIndex < columnNames.length; columnIndex++) {
                        var val = row[columnNames[columnIndex]];
                        rowItems.push(val);
                    }

                    csvContent.push(rowItems);
                }
            }

            if(groupBy){
                csvContent.push([topLine]);
                csvContent.push([]);
                // Group data by category
                let groupedData = data.reduce((acc, row) => {
                    let category = row[groupBy];
                    if (!acc[category]) {
                        acc[category] = [];
                    }
                    acc[category].push(row);
                    return acc;
                }, {});

                // Loop through each category and its rows
                for (let category in groupedData) {
                    csvContent.push([category]);

                    csvContent.push(header); // Add column headings for each category

                    let rows = groupedData[category];

                    // Loop through each row in the current category
                    processCsvRows(rows);
                }
            }else{
                csvContent.push([topLine])
                csvContent.push(header);

                processCsvRows(data);
            }

            let managedAccounts = this.report.managedAccounts;
            if(managedAccounts){
                Object.keys(managedAccounts).forEach(key => {
                    if(managedAccounts[key].items && managedAccounts[key].items.length){
                        csvContent.push(["CG Managed Accounts"])
                        for (var i = 0; i < managedAccounts[key].items.length; i++) {
                            if (managedAccounts[key].items[i] && managedAccounts[key].items[i].items && managedAccounts[key].items[i].items.length > 0) {
                                let asset = managedAccounts[key].items[i];
                                csvContent.push([asset.categoryName, "", "", "", asset.subtotal.totalCost, "", asset.subtotal.marketValue, asset.subtotal.profitOrLoss, asset.subtotal.pctAssets, "", "", ""])
                                csvContent.push(header);
    
                                processCsvRows(asset.items);
                            }
                        }
        
                    }
                })
            }

            let csvTotalColumnNames = columnDefinition.csvTotalColumnNames;
            let csvTotalDisplayNames = columnDefinition.csvTotalDisplayNames;

            if(columnDefinition.csvTotalColumnNames){
                let totals = this.report.grandTotal;

                //Grand totals
                csvContent.push(csvTotalDisplayNames);

                var rowItems = [];
                for (var columnIndex = 0; columnIndex < csvTotalColumnNames.length; columnIndex++) {
                    var val = totals[csvTotalColumnNames[columnIndex]];
                    
                    rowItems.push(val || "");
                }
                csvContent.push(rowItems);
                
            }
            let EOL: string = '\r\n';
            let csvContentString: string = "";

            for (let row of csvContent) {
                let rowItems: any[] = [];

                for (let field of row) {
                    let val: any = field;

                    if (val === undefined || val === null) {
                        val = "";
                    }

                    if (typeof val === 'string') {
                        val = val.replace(/"/g, '""');
                    }

                    if (typeof val === 'number') {
                        rowItems.push(val);
                    } else {
                        rowItems.push('"' + val + '"');
                    }
                }

                csvContentString += rowItems.join(',') + EOL;
            }


            return new Blob([csvContentString], { type: 'text/csv;charset=utf-8' });
        }

        getColumnNames() {
            var definitions = this.getColumnDefinitions(this.report.reportType);
            return definitions ? definitions.columnNames : null;
        }

        getCsvColumnHeadings() {
            var definitions = this.getColumnDefinitions(this.report.reportType);
            return definitions ? definitions.csvDisplayNames : null;
        }

        getCsvColumnNames() {
            var definitions = this.getColumnDefinitions(this.report.reportType);
            return definitions ? definitions.csvColumnNames : null;
        }

        public static getCsvTopLine(account: Account, creationDateUtc: Date, dateFrom: Date, dateTo: Date, asAtDate: Date): string {
            let adviser = account.adviserName ? account.adviserName :
                account.adviserCode ? account.adviserCode : "<unknown>";
            let timestamp = moment.tz(creationDateUtc,'Australia/Sydney').format("h:mm a [AEST on] D MMM YYYY");

            let dateString: string;
            if (asAtDate === undefined) {
                let fromDateStr = moment(dateFrom).format("[From:] D MMM YYYY");
                let toDateStr = moment(dateTo).format("[To:] D MMM YYYY");
                dateString = fromDateStr + ' ' + toDateStr;
            } else {
                let asAtDateStr = moment(asAtDate).format("[As at:] D MMM YYYY");
                dateString = asAtDateStr;
            }

            return 'Adviser: ' + adviser +
                ', Account: ' + account.accountId +
                ', ' + dateString +
                ', Report generated at: ' + timestamp;
        }

        getCsvData() {
            switch (this.report.reportType) {
                case ReportType.CapitalTransactions:
                    return this.getCapitalTransactionStatementCsv();
                case ReportType.QuarterlyReports:
                    return this.getQuarterlyReportsCsv();
                case ReportType.Cash:
                    return this.getCashCsv();
                case ReportType.Income:
                    return this.getIncomeCsv();
                case ReportType.CapitalGains:
                    return this.getCapitalGainsCsv();
                case ReportType.UnrealisedCapitalGains:
                    return this.getUnrealisedCapitalGainsCsv();
                case ReportType.Performance:
                    return this.getPerformanceCsv();
                case ReportType.TaxReports:
                    return this.getTaxReportsCsv();
                case ReportType.Valuation:
                    return this.getValuationStatementCsv();
                case ReportType.StandardLedger:
                    return this.getStandardLedgerCsv();
                default:
                    console.error('Unrecognised report type encountered: ' + this.report.reportType);
                    return null;
            }
        }
        getCapitalTransactionStatementCsv() {
            var result: any = [], csvData: any;
            var statement = this.report as CapitalTransactionStatement;
            var transactions;
            if (statement && statement.tradeCategories && statement.tradeCategories.length > 0) {
                var categories = statement.tradeCategories;
                for (var i = 0; i < categories.length; i++) {
                    var category = categories[i];
                    transactions = category.transactions;
                    csvData = angular.copy(transactions);
                    csvData.map((txn) => {
                        delete txn.isSell;
                        delete txn.sign;
                        return this.formatDataRow(txn);
                    });
                    result = result.concat(csvData);
                }
            }
            return result;
        }
        getCapitalGainsCsv() {
            var result: any = [], csvData: any;
            var report = this.report as RealisedCapitalGainsReport;
            if (report && report.assetClasses.length > 0) {
                var assetClasses = report.assetClasses as RealisedCapitalGainsAssetClass[];
                for (var i = 0; i < assetClasses.length; i++) {
                    var assetClass = assetClasses[i] as RealisedCapitalGainsAssetClass;
                    var assets = assetClass.assets as RealisedCapitalGainsAsset[];
                    for (var j = 0; j < assets.length; j++) {
                        var asset = assets[j] as RealisedCapitalGainsAsset;
                        var capitalGains = asset.capitalGains as RealisedCapitalGain[];
                        csvData = angular.copy(capitalGains);
                        csvData.map((txn) => {
                            return this.formatDataRow(txn);
                        });
                        result = result.concat(csvData);
                    }
                }
            }
            return result;
        }
        getUnrealisedCapitalGainsCsv() {
            var result: any = [], csvData: any;
            var report = this.report as UnrealisedCapitalGainsReport;
            if (report && report.assetClasses.length > 0) {
                var assetClasses = report.assetClasses as UnrealisedCapitalGainsAssetClass[];
                for (var i = 0; i < assetClasses.length; i++) {
                    var assetClass = assetClasses[i] as UnrealisedCapitalGainsAssetClass;
                    var assets = assetClass.assets as UnrealisedCapitalGainsAsset[];
                    for (var j = 0; j < assets.length; j++) {
                        var asset = assets[j] as UnrealisedCapitalGainsAsset;
                        var capitalGains = asset.capitalGains as UnrealisedCapitalGain[];
                        csvData = angular.copy(capitalGains);
                        csvData.map((txn) => {
                            return this.formatDataRow(txn);
                        });
                        result = result.concat(csvData);
                    }
                }
            }
            return result;
        }
        getPerformanceCsv() {
            var report = this.report as PerformanceReport;
            return [report];
        }
        getQuarterlyReportsCsv() {

            var result: any = [], csvData: any;
            var quarterlyReportsListReport = this.report as QuarterlyReportsListReport;

            if (quarterlyReportsListReport && quarterlyReportsListReport.investorDocs && quarterlyReportsListReport.investorDocs.length > 0) {
                var entries = quarterlyReportsListReport.investorDocs;
                csvData = angular.copy(entries);
                csvData.map((txn) => {
                    return this.formatDataRow(txn);
                });
                result = result.concat(csvData);
            }

            return result;
        }
        getTaxReportsCsv() {

            var result: any = [], csvData: any;
            var taxReportsListReport = this.report as TaxReportsListReport;

            if (taxReportsListReport && taxReportsListReport.investorDocs && taxReportsListReport.investorDocs.length > 0) {
                var entries = taxReportsListReport.investorDocs;
                csvData = angular.copy(entries);
                csvData.map((txn) => {
                    return this.formatDataRow(txn);
                });
                result = result.concat(csvData);
            }

            return result;
        }
        getCashCsv() {
            var result: any = [], csvData: any;
            var cashReport = this.report as CashReport;
            if (cashReport && cashReport.transactionGroups && cashReport.transactionGroups.length > 0) {
                var groups = cashReport.transactionGroups;
                for (var i = 0; i < groups.length; i++) {
                    var group = groups[i];
                    var transactions = group.transactions;
                    csvData = angular.copy(transactions);
                    csvData.map((txn) => {
                        delete txn.aac;
                        delete txn.accountName;
                        delete txn.netValue;
                        delete txn.openingBalance;
                        return this.formatDataRow(txn);
                    });
                    result = result.concat(csvData);
                }
            }
            return result;
        }
        getIncomeCsv() {
            var result: any = [], csvData: any, transactions: IncomeReportLineItem[];
            var columnDefinitions = this.getColumnDefinitions(this.report.reportType);
            var headerCols = columnDefinitions.columnNames;
            var displayHeaderCols = columnDefinitions.displayNames;
            var widths = columnDefinitions.columnWidths;
            var incomeReport = this.report as IncomeReport;
            var transactionTypeCategories = incomeReport.transactionTypeCategories;

            if (transactionTypeCategories && transactionTypeCategories.length > 0) {
                for (var cat = 0; cat < transactionTypeCategories.length; cat++) {
                    let subcategories = transactionTypeCategories[cat].subCategories;
                    for (var subCat = 0; subCat < subcategories.length; subCat++) {
                        var lineItems = subcategories[subCat].lineItems;
                        csvData = angular.copy(lineItems);
                        csvData.map((txn) => {
                            return this.formatDataRow(txn);
                        });
                        result = result.concat(csvData);
                    }
                }
            }

            return result;
        }

        getStandardLedgerCsv() {
            var result: any = [], csvData: any, transactions: LedgerEntry[];
            var standardLedgerReport = this.report as StandardLedgerReport;

            if (standardLedgerReport && standardLedgerReport.ledgerEntries && standardLedgerReport.ledgerEntries.length > 0) {
                var entries = standardLedgerReport.ledgerEntries;
                csvData = angular.copy(entries);
                csvData.map((txn) => {
                    return this.formatDataRow(txn);
                });
                result = result.concat(csvData);
            }

            return result;
        }

        getValuationStatementCsv() {
            let result: any = [];
            let csvData: any;
            let statement = this.report as ValuationStatement;
            if (statement.nonLoaSecurities && statement.nonLoaSecurities.length > 0) {
                let categories = statement.nonLoaSecurities;
                categories.forEach(cat => {
                    csvData = angular.copy(cat.items);
                    csvData = csvData.map((itm) => {
                        return {
                            category: itm.categoryName,
                            code: itm.code,
                            securityName: itm.securityName,
                            quantity: itm.quantity,
                            costPrice: this.safeFixedDecimals(itm.costPrice, 4),
                            totalCost: this.safeFixedDecimals(itm.totalCost, 2),
                            price: this.safeFixedDecimals(itm.price, 4),
                            marketValue: this.safeFixedDecimals(itm.marketValue, 2),
                            profitOrLoss: this.safeFixedDecimals(itm.profitOrLoss, 2),
                            pctAssets: this.safeFixedDecimals(itm.pctAssets, 2),
                            estAnnualIncome: this.safeFixedDecimals(itm.estAnnualIncome, 2),
                            estFrankingCredits: this.safeFixedDecimals(itm.estFrankingCredits, 2),
                            estGrossYield: this.safeFixedDecimals(itm.estGrossYield, 2)
                        };
                    });
                    result = result.concat(csvData);
                });
            }
            if (statement.nonLoaUnsettledDividends && statement.nonLoaUnsettledDividends.items && statement.nonLoaUnsettledDividends.items.length > 0) {
                let dividends = statement.nonLoaUnsettledDividends;
                csvData = angular.copy(dividends.items);
                csvData = csvData.map((itm) => {
                    return {
                        category: "Unsettled Dividends",
                        code: itm.securityCode,
                        securityName: itm.securityName,
                        quantity: null,
                        costPrice: null,
                        totalCost: null,
                        price: null,
                        marketValue: this.safeFixedDecimals(itm.unsettledIncome, 2),
                        profitOrLoss: null,
                        pctAssets: null,
                        estAnnualIncome: null,
                        estFrankingCredits: null,
                        estGrossYield: null
                    };
                });
                result = result.concat(csvData);
            }
            if (statement.loaSecurities && statement.loaSecurities.length > 0) {
                let categories = statement.loaSecurities;
                categories.forEach(cat => {
                    csvData = angular.copy(cat.items);
                    csvData = csvData.map((itm) => {
                        return {
                            category: itm.categoryName,
                            code: itm.code,
                            securityName: itm.securityName,
                            quantity: itm.quantity,
                            costPrice: this.safeFixedDecimals(itm.costPrice, 4),
                            totalCost: this.safeFixedDecimals(itm.totalCost, 2),
                            price: this.safeFixedDecimals(itm.price, 4),
                            marketValue: this.safeFixedDecimals(itm.marketValue, 2),
                            profitOrLoss: this.safeFixedDecimals(itm.profitOrLoss, 2),
                            pctAssets: this.safeFixedDecimals(itm.pctAssets, 2),
                            estAnnualIncome: this.safeFixedDecimals(itm.estAnnualIncome, 2),
                            estFrankingCredits: this.safeFixedDecimals(itm.estFrankingCredits, 2),
                            estGrossYield: this.safeFixedDecimals(itm.estGrossYield, 2)
                        };
                    });
                    result = result.concat(csvData);
                });
            }
            if (statement.loaUnsettledDividends && statement.loaUnsettledDividends.items && statement.loaUnsettledDividends.items.length > 0) {
                let dividends = statement.loaUnsettledDividends;
                csvData = angular.copy(dividends.items);
                csvData = csvData.map((itm) => {
                    return {
                        category: "Unsettled Dividends",
                        code: itm.securityCode,
                        securityName: itm.securityName,
                        quantity: null,
                        costPrice: null,
                        totalCost: null,
                        price: null,
                        marketValue: this.safeFixedDecimals(itm.unsettledIncome, 2),
                        profitOrLoss: null,
                        pctAssets: null,
                        estAnnualIncome: null,
                        estFrankingCredits: null,
                        estGrossYield: null
                    };
                });
                result = result.concat(csvData);
            }
            return result;
        }
        safeFixedDecimals(value: number, decimals: number): number {
            if (value === null || value === undefined) {
                return undefined;
            }

            return parseFloat(value.toFixed(decimals));
        }

        getPerformanceLayout(){
          return {
            hLineWidth: (i, node) => { return 1; },
            vLineWidth: (i, node) => { return 1; },
            hLineColor: (i, node) => {
              if (i === 1 || i === node.table.body.length-1) { return this.userCompany.colorSecondary }
              else { return 'lightgray'; }
            },
            vLineColor: (i, node) => { return 'lightgray'; }
          }
        }

        getTablelayout(subtotal: boolean, total: boolean, headers: boolean, holdings: boolean, noFooter: boolean = null): any {
          if (holdings){
            return {
              hLineWidth: (i, node) => { return 1; },
              vLineWidth: (i, node) => { return 1; },
                hLineColor: (i, node) => {
                if (i === 0) { return 'black'; }
                if (i === 2 || i === node.table.body.length-1) { return this.userCompany.colorSecondary; }
                else { return 'lightgray'; }
                //return 'lightgray';
              },
              vLineColor: (i, node) => { return 'lightgray'; }
            }
          }
          if (subtotal){
            return {
                hLineWidth: (i, node) => { return 1; },
                vLineWidth: (i, node) => { return 1; },
                hLineColor: (i, node) => {
                  if (i === 0) { return this.userCompany.colorSecondary; }
                },
                vLineColor: (i, node) => { return 'lightgray'; }
            }
          }
          if (total){
            return {
                hLineWidth: (i, node) => { return 1; },
                vLineWidth: (i, node) => { return 1; },
                hLineColor: (i, node) => {
                  if (i === 0) { return this.userCompany.colorSecondary; }
                },
                vLineColor: (i, node) => { return 'lightgray'; }
            }
          }
          if (headers){
            return {
              hLineWidth: (i, node) => { return 1; },
              vLineWidth: (i, node) => { return 1; },
              hLineColor: (i, node) => {
                if (i === 1 || i === node.table.body.length-1) { return this.userCompany.colorSecondary; }
                else { return 'lightgray'; }
              },
              vLineColor: (i, node) => { return 'lightgray'; }
            }
          }
          if (noFooter){
            return {
              hLineWidth: (i, node) => { return 1; },
              vLineWidth: (i, node) => { return 1; },
              hLineColor: (i, node) => {
                if (i === 1) { return this.userCompany.colorSecondary; }
                else { return 'lightgray'; }
              },
              vLineColor: (i, node) => { return 'lightgray'; }
            }
          }

          return {
            hLineWidth: (i, node) => { return 1; },
            vLineWidth: (i, node) => { return 1; },
            //hLineColor: function(i, node) { return 'lightgray';},
            hLineColor: (i, node) => {
              if (i === node.table.body.length) { return this.userCompany.colorSecondary; }
              else { return 'lightgray'; }
            },
            vLineColor: (i, node) => { return 'lightgray'; }
          }
        }

        layoutThinLightBorderHeader(): any {
            return {
                hLineWidth: (i, node) => { return 1; },
                vLineWidth: (i, node) => { return 1; },
                hLineColor: (i, node) => {
                  if (i === 1 || i === node.table.body.length-1) { return this.userCompany.colorSecondary; }
                  else { return 'lightgray'; }
                },
                vLineColor: (i, node) => { return 'lightgray'; },
            }
        }

        layoutThinLightBorderHeaderHoldings(): any {
            return {
                hLineWidth: (i, node) => { return 1; },
                vLineWidth: (i, node) => { return 1; },
                hLineColor: (i, node) => {
                  if (i === 2 || i === node.table.body.length-1) { return this.userCompany.colorSecondary; }
                  else { return 'lightgray'; }
                },
                vLineColor: (i, node) => { return 'lightgray'; },
            }
        }

        layoutThinLightBorder(): any {
            return {
                hLineWidth: (i, node) => { return 1; },
                vLineWidth: (i, node) => { return 1; },
                //hLineColor: function(i, node) { return 'lightgray';},
                hLineColor: (i, node) => {
                  if (i === node.table.body.length) { return this.userCompany.colorSecondary; }
                  else { return 'lightgray'; }
                },
                vLineColor: (i, node) => { return 'lightgray'; },
            }
        }
    }
}
